import { KNOTS_TO_MPS } from './flightMotion.js';

const M_PER_DEG_LAT = 111_320;
const DEG = Math.PI / 180;

/**
 * Dead-reckon a position forward. Given a start [lon,lat], a compass heading
 * (degrees clockwise from north), a ground speed (knots), and elapsed time (ms),
 * returns the projected [lon,lat] using an equirectangular approximation — exact
 * enough at city scale over a few seconds of flight.
 */
export function projectPosition(
  lon: number,
  lat: number,
  headingDeg: number,
  gsKt: number,
  dtMs: number,
): [number, number] {
  const distM = gsKt * KNOTS_TO_MPS * (dtMs / 1000);
  if (distM === 0) return [lon, lat];
  const hdg = headingDeg * DEG;
  const dLat = (distM * Math.cos(hdg)) / M_PER_DEG_LAT;
  const mPerDegLon = M_PER_DEG_LAT * Math.cos(lat * DEG);
  const dLon = mPerDegLon > 0 ? (distM * Math.sin(hdg)) / mPerDegLon : 0;
  return [lon + dLon, lat + dLat];
}
